import TaxSettings from 'components/taxSettings/TaxSettings';
import React from 'react';

const TaxSettingsTab: React.FC = () => {
  return (
    <div>
        <TaxSettings />
    </div>
  );
};

export default TaxSettingsTab;
